import {
  InnerContent,
  SimpleModal,
  SimpleModalHeader,
  SimpleModalHeaderIcon,
  SimpleModalTitle,
} from '@fountain/fountain-ui-components';
import Grid from '@material-ui/core/Grid';
import filter from 'lodash/filter';
import PropTypes from 'prop-types';
import React from 'react';

import InfoBlueIcon from 'images/info-blue.svg';

import PartnerDetail from './components/PartnerDetail';

function PartnerDetailsModal({ partnerDetails, validity, handleClose, title }) {
  const activeDetails = filter(partnerDetails, detail => detail.active);
  const inactiveDetails = filter(partnerDetails, detail => !detail.active);

  return (
    <SimpleModal onClose={handleClose}>
      <SimpleModalHeader onClose={handleClose}>
        <SimpleModalHeaderIcon Icon={InfoBlueIcon} color="blue" />
        <SimpleModalTitle>{title}</SimpleModalTitle>
      </SimpleModalHeader>

      <InnerContent>
        <Grid>
          <PartnerDetail details={activeDetails} validity={validity} />
          <PartnerDetail details={inactiveDetails} requestedRevision />
        </Grid>
      </InnerContent>
    </SimpleModal>
  );
}

PartnerDetailsModal.propTypes = {
  partnerDetails: PropTypes.array,
  // Describes the package, not one row, so it rides beside the details rather
  // than among them. Only the active block carries it: a row retired by a
  // revision request says nothing about the check that is in force.
  validity: PropTypes.shape({
    state: PropTypes.oneOf(['valid', 'expired']).isRequired,
    date: PropTypes.string.isRequired,
  }),
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default PartnerDetailsModal;
